webpackJsonp([1],{

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return host; });
var host =  true ? '' : 'http://localhost:8082';

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkMobile; });
function checkMobile(sMobile) {
  if (!/^1[3-9]\d{9}$/.test(sMobile)) {
    return false;
  }
  return true;
}



/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NameRegister__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NameRegister___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NameRegister__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Shop__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Shop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Shop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Checkout__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Address__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Address___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Address__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_NewAddress__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_NewAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_NewAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CheckoutSuccess__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CheckoutSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_CheckoutSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CheckoutStatus__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CheckoutStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_CheckoutStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Orders__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Orders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Orders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SupportOrders__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SupportOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SupportOrders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SupplierOrders__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SupplierOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_SupplierOrders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DeliveryOrders__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DeliveryOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_DeliveryOrders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SupportOrderDetail__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SupportOrderDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_SupportOrderDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SupplierOrderDetail__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SupplierOrderDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_SupplierOrderDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_DeliveryOrderDetail__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_DeliveryOrderDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_DeliveryOrderDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_SalesOrders__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_SalesOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_SalesOrders__);



















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Shop',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Shop___default.a
  }, {
    path: '/login/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login___default.a
  }, {
    path: '/name-register/',
    name: 'NameRegister',
    component: __WEBPACK_IMPORTED_MODULE_3__components_NameRegister___default.a
  }, {
    path: '/shop/',
    name: 'Shop',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Shop___default.a
  }, {
    path: '/checkout/',
    name: 'Checkout',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Checkout___default.a
  }, {
    path: '/address/',
    name: 'Address',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Address___default.a
  }, {
    path: '/new_address/',
    name: 'NewAddress',
    component: __WEBPACK_IMPORTED_MODULE_7__components_NewAddress___default.a
  }, {
    path: '/checkout-success/',
    name: 'CheckoutSuccess',
    component: __WEBPACK_IMPORTED_MODULE_8__components_CheckoutSuccess___default.a
  }, {
    path: '/orders/',
    name: 'Orders',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Orders___default.a
  }, {
    path: '/support/orders/',
    name: 'SupportOrders',
    component: __WEBPACK_IMPORTED_MODULE_11__components_SupportOrders___default.a
  }, {
    path: '/support/order/:id',
    name: 'SupportOrderDetail',
    component: __WEBPACK_IMPORTED_MODULE_14__components_SupportOrderDetail___default.a
  }, {
    path: '/supplier/:id/orders/',
    name: 'SupplierOrders',
    component: __WEBPACK_IMPORTED_MODULE_12__components_SupplierOrders___default.a
  }, {
    path: '/supplier/order/:id',
    name: 'SupplierOrderDetail',
    component: __WEBPACK_IMPORTED_MODULE_15__components_SupplierOrderDetail___default.a
  }, {
    path: '/order/',
    name: 'Order',
    component: __WEBPACK_IMPORTED_MODULE_9__components_CheckoutStatus___default.a
  }, {
    path: '/delivery/:id/orders/',
    name: 'DeliveryOrders',
    component: __WEBPACK_IMPORTED_MODULE_13__components_DeliveryOrders___default.a
  }, {
    path: '/delivery/order/:id',
    name: 'DeliveryOrderDetail',
    component: __WEBPACK_IMPORTED_MODULE_16__components_DeliveryOrderDetail___default.a
  }, {
    path: '/sales/:id/orders/',
    name: 'SalesOrders',
    component: __WEBPACK_IMPORTED_MODULE_17__components_SalesOrders___default.a
  }]
}));

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_cart__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_products__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_addresses__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_orders__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_config__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins__ = __webpack_require__(245);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  modules: {
    cart: __WEBPACK_IMPORTED_MODULE_4__modules_cart__["a" /* default */],
    products: __WEBPACK_IMPORTED_MODULE_5__modules_products__["a" /* default */],
    addresses: __WEBPACK_IMPORTED_MODULE_6__modules_addresses__["a" /* default */],
    orders: __WEBPACK_IMPORTED_MODULE_7__modules_orders__["a" /* default */],
    configs: __WEBPACK_IMPORTED_MODULE_8__modules_config__["a" /* default */]
  },
  strict: debug,
  plugins: __WEBPACK_IMPORTED_MODULE_9__plugins__["a" /* default */]
}));

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(40);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      phone: '',
      contatct: '',
      address: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    oldAddress: 'myAddress',
    forCustomer: 'forCustomer'
  })),

  created: function created() {
    this.contact = this.oldAddress.name;
    this.phone = this.oldAddress.tel;
    this.address = this.oldAddress.street;
  },


  methods: {
    saveAddress: function saveAddress() {
      var phone = this.phone;
      var contact = this.contact;
      var address = this.address;
      if (!contact) {
        alert("请填写联系人！");
        return false;
      }
      if (!address) {
        alert("请填写地址！");
        return false;
      }
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        alert("请填写正确手机号！");
        return false;
      }
      if (!this.oldAddress._id) {
        this.$store.dispatch('saveAddress', { forCustomer: this.forCustomer, address: { phone: phone, contact: contact, address: address } });
      } else if (!(phone == this.oldAddress.tel && contact == this.oldAddress.name && this.oldAddress.street == address)) {
        this.$store.dispatch('editAddress', { forCustomer: this.forCustomer, address: { phone: phone, contact: contact, address: address, _id: this.oldAddress._id } });
      }
      this.$router.go(-1);
    },
    checkValid: function checkValid() {
      return !(!!this.contact && !!this.phone && !!this.address && /^1[3-9]\d{9}$/.test(this.phone));
    }
  }

});

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(40);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      notes: '',
      msg: 'Welcome to Your Vue.js App',
      deliveryTime: '明天7:00-8:00',
      reachPay: false,
      showReachPay: false,
      placingOrder: false,
      wechatPayParams: null,
      orderId: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    goods: 'allProducts',
    cartGoods: 'cartProducts',
    productCartNum: 'productCartNum',
    totalPrice: 'totalPrice',
    checkoutStatus: 'checkoutStatus',
    address: 'myAddress',
    config: 'config',
    forCustomer: 'forCustomer'
  })),

  created: function created() {
    this.$store.dispatch('getMyAddresses', this.forCustomer);
    this.getNotesFromStore();
    if (window.localStorage.getItem('zrb-first-order') != 'true') {
      this.showReachPay = true;
    }

    if (!this.goods.length) {
      this.$store.dispatch('getAllProducts');
    }
  },


  methods: {
    getNotesFromStore: function getNotesFromStore() {
      var notesStoreKey = this.forCustomer || 'own';
      notesStoreKey += '-notes';
      this.notes = localStorage.getItem(notesStoreKey);
    },
    saveNotesToStore: function saveNotesToStore() {
      var notesStoreKey = this.forCustomer || 'own';
      notesStoreKey += '-notes';
      localStorage.setItem(notesStoreKey, this.notes);
    },
    goToAddressList: function goToAddressList() {
      this.$router.push('/address');
    },
    placeOrder: function placeOrder() {
      var _this = this;

      this.saveNotesToStore();
      if (!this.address.name) {
        alert("请填写配送地址");
        return;
      }
      if (!this.deliveryTime) {
        alert("请填写配送时间");
        return;
      }
      if (confirm('确认下单?')) {
        this.placingOrder = true;
        this.$store.dispatch('checkout', { forCustomer: this.forCustomer, order: { products: this.cartGoods, address: { name: this.address.name, tel: this.address.tel, street: this.address.street }, notes: this.notes, dueTime: this.deliveryTime } }).then(function (response) {
          _this.placingOrder = false;
          _this.$store.dispatch('clearCart');
          _this.$router.replace('/checkout-success/');
        }, function (error) {
          _this.placingOrder = false;
        });
      }
    }
  }

});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(12);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      order: {},
      orderFound: 0,
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '待支付',
        3: '已完成'
      }
    };
  },

  computed: {
    address: function address() {
      return this.order && this.order.address || {};
    }
  },

  created: function created() {
    this.getOrder();
  },


  methods: {
    getOrder: function getOrder() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + '/api/order/' + this.$route.query.id).then(function (res) {
        _this.order = res.data.data;
      });
    },
    orderPrePay: function orderPrePay() {
      var _this2 = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + '/api/order/prepay/' + this.order._id).then(function (res) {
        _this2.params = res.data.data;
        _this2.invokePay();
      });
    },
    queryOrder: function queryOrder() {
      var _this3 = this;

      this.$http.get('/api/order/query/' + this.order._id).then(function (res) {
        if (res.data.data != "SUCCESS") {
          _this3.order.status = res.data.data;
          _this3.alert('支付失败');
        } else {
          _this3.getOrder();
        }
      });
    },
    invokePay: function invokePay() {
      var self = this;
      var data = this.params;
      function onBridgeReady() {
        WeixinJSBridge.invoke('getBrandWCPayRequest', data, function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            self.queryOrder();
          } else {}
        });
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    },
    cancelOrder: function cancelOrder() {
      var _this4 = this;

      if (confirm('确认取消订单？')) {
        this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + '/api/order/cancel', { _id: this.order._id }).then(function () {
          _this4.getOrder();
        });
      }
    }
  }

});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },
  created: function created() {
    window.localStorage.setItem('zrb-first-order', 'true');
  },

  methods: {
    goToHome: function goToHome() {
      this.$router.replace('/shop');
    }
  }
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_util__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */])()],
  data: function data() {
    return {
      order: {},
      suppliers: [],
      orderFound: 0,
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '已核对',
        3: '已完成'
      }
    };
  },

  computed: {
    address: function address() {
      return this.order && this.order.address || {};
    },
    roughPrice: function roughPrice() {
      var result = 0;
      this.order.products && this.order.products.forEach(function (g) {
        result += Math.round(100 * g.quantity * g.price) / 100;
      });
      return result;
    },
    supplierMap: function supplierMap() {
      var map = {};
      this.suppliers.forEach(function (s) {
        map[s._id] = s.name;
      });
      return map;
    }
  },

  created: function created() {
    var _this = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + '/api/supplier/list', { withCredentials: true }).then(function (res) {
      _this.suppliers = res.data.data;
    });
    this.getOrder();
  },


  methods: {
    getOrder: function getOrder() {
      var _this2 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + '/api/order/' + this.$route.params.id).then(function (res) {
        _this2.order = res.data.data;
      });
    }
  }

});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */])()],
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '已核对',
        3: '已完成'
      },
      orders: [],
      suppliers: []
    };
  },

  methods: {
    goToDetail: function goToDetail(order) {
      this.$router.push('/delivery/order/' + order._id);
    }
  },
  computed: {
    supplierMap: function supplierMap() {
      var map = {};
      this.suppliers.forEach(function (s) {
        map[s._id] = s.name;
      });
      return map;
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + ('/api/delivery/' + this.$route.params.id + '/order/list'), { withCredentials: true }).then(function (res) {
      _this.orders = res.data.data;
    });
    this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + '/api/supplier/list', { withCredentials: true }).then(function (res) {
      _this.suppliers = res.data.data;
    });
    this.getLogin().then(function (res) {
      if (!res) {
        _this.$router.push('/login');
      }
    });
  },

  filters: {
    calStatus: function calStatus(val) {
      var res = '';
      switch (val) {
        case "0":
          res = '订单已失效';
          break;
        case "1":
          res = '待支付';
          break;
        case "2":
          res = '支付成功';
          break;
        case "3":
          res = '已取消';
          break;
        case "4":
          res = '订单到付';
          break;
      }
      return res;
    }
  }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(40);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      phone: '',
      code: '',
      buttonText: '获取验证码',
      phoneValidate: true,
      codeValidate: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    showTip: function showTip() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_js__["a" /* checkMobile */])(this.phone);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    config: 'config'
  })),
  watch: {
    phone: function phone() {
      if (/^1[3456789]\d{9}$/.test(this.phone)) {
        this.phoneValidate = true;
      } else {
        this.phoneValidate = false;
      }
    }
  },
  methods: {
    getCode: function getCode() {
      var _this = this;

      if (!this.showTip) {
        this.$http.get(this.config.host + '/api/customer/code?phone=' + this.phone).then(function (data) {
          console.log(data);
        });
      }
      var i = 60;
      this.buttonText = i + 's\u91CD\u65B0\u83B7\u53D6';
      var timer = setInterval(function () {
        if (i > 0) {
          i--;
          _this.buttonText = i + 's\u91CD\u65B0\u83B7\u53D6';
        } else {
          clearInterval(timer);
          _this.buttonText = '获取验证码';
        }
      }, 1000);
    },
    login: function login() {
      var _this2 = this;

      this.$http.post(this.config.host + '/api/customer/login', {
        phone: this.phone,
        code: this.code
      }).then(function (res) {
        if (res.data.data.success) {
          localStorage.setItem("roupoo-token", res.data.data.token);
          if (res.data.data.name) {
            _this2.$router.replace('/');
          } else {
            _this2.$router.push({ name: 'NameRegister', query: { phone: _this2.phone } });
          }
        } else {
          _this2.codeValidate = false;
        }
      });
    }
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(40);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      phone: '',
      code: '',
      buttonText: '获取验证码',
      phoneValidate: true,
      codeValidate: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    showTip: function showTip() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_js__["a" /* checkMobile */])(this.phone);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    config: 'config'
  })),

  methods: {
    submit: function submit() {
      var _this = this;

      this.$http.put(this.config.host + '/api/customer/name-register', {
        phone: this.$route.query.phone, name: this.name
      }).then(function (res) {
        if (res.data.data.success) {
          _this.$router.replace('/');
        }
        console.log(data);
      });
    }
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(40);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      district: '',
      street: '',
      msg: 'Welcome to Your Vue.js App'
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    config: 'config'
  })),

  methods: {
    saveAddress: function saveAddress() {
      var _this = this;

      var token = localStorage.getItem('roupooToken');

      this.$http.post(this.config.host + '/admin/api/v1/addresses.json', { street: this.district + this.street }).then(function (data) {
        _this.$router.push('/address');
      });
    }
  }

});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dateformat__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dateformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(33);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */])()],
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '待支付',
        3: '已完成'
      },
      customer: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    orders: 'allOrders'
  })),
  methods: {
    goToDetail: function goToDetail(order) {
      this.$router.push('/order/?id=' + order._id);
    }
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('getAllOrders');
    this.getLogin().then(function (res) {
      if (!res) {
        _this.$router.push('/login');
      } else {
        _this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + '/api/customer/info', { withCredentials: true }).then(function (res) {
          _this.customer = res.data.data;
        }).catch(function (e) {
          console.log(e.response.data.message);
        });
      }
    });
  },

  filters: {
    filterTime: function filterTime(val) {
      return __WEBPACK_IMPORTED_MODULE_2_dateformat___default()(new Date(val), "yyyy-mm-dd HH:MM:ss");
    },
    calStatus: function calStatus(val) {
      var res = '';
      switch (val) {
        case "0":
          res = '订单已失效';
          break;
        case "1":
          res = '待支付';
          break;
        case "2":
          res = '支付成功';
          break;
        case "3":
          res = '已取消';
          break;
        case "4":
          res = '订单到付';
          break;
      }
      return res;
    }
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */])()],
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '已核对',
        3: '已完成'
      },
      orders: [],
      suppliers: [],
      dateRange: ''
    };
  },

  methods: {
    goToDetail: function goToDetail(order) {},
    getOrdersByDateRange: function getOrdersByDateRange(startDate, endDate) {
      var _this = this;

      console.log(this.$route.params.id);
      console.log(startDate);
      console.log(endDate);
      this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + ('/api/sales/' + this.$route.params.id + '/order/list') + "?" + "startDate=" + startDate + "&endDate=" + endDate, { withCredentials: true }).then(function (res) {
        console.log(res.data.data);
        _this.orders = res.data.data;
      });
    },
    getAllOrders: function getAllOrders() {}
  },
  computed: {
    supplierMap: function supplierMap() {
      var map = {};
      this.suppliers.forEach(function (s) {
        map[s._id] = s.name;
      });
      return map;
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + ('/api/sales/' + this.$route.params.id + '/order/list'), { withCredentials: true }).then(function (res) {
      console.log(res);
      _this2.orders = res.data.data;
    });
    this.getLogin().then(function (res) {
      if (!res) {
        _this2.$router.push('/login');
      }
    });
  },

  filters: {
    calStatus: function calStatus(val) {
      var res = '';
      switch (val) {
        case "0":
          res = '订单已失效';
          break;
        case "1":
          res = '待支付';
          break;
        case "2":
          res = '支付成功';
          break;
        case "3":
          res = '已取消';
          break;
        case "4":
          res = '订单到付';
          break;
      }
      return res;
    }
  }
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pinch_slider__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pinch_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pinch_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_timers__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_utils__ = __webpack_require__(33);





__webpack_require__(490);








__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_pinch_slider__["AlloyFingerVue"], { AlloyFinger: __WEBPACK_IMPORTED_MODULE_5_pinch_slider__["AlloyFinger"] });
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('slider', __WEBPACK_IMPORTED_MODULE_5_pinch_slider__["PinchSlider"]);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'shop',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__mixins_utils__["a" /* default */])()],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    goods: 'allProducts',
    categories: 'categories',
    cartGoods: 'cartProducts',
    productCartNum: 'productCartNum',
    checkoutStatus: 'checkoutStatus',
    totalPrice: 'totalPrice',
    productCartTotalNum: 'productCartTotalNum',
    forCustomer: 'forCustomer'
  }), {
    openTime: function openTime() {
      var d = new Date();
      var h = d.getHours();
      return h > 5 && h < 23 || h == 23 && d.getMinutes() < 30;
    }
  }),
  data: function data() {
    return {
      forCustomers: [],
      minMoney: 0,
      cartShow: false,
      specsShow: false,
      currentSpec: '',
      currentUnit: '',
      msg: 'Welcome to Your Vue.js App',
      slides: [],
      currentCategoryIndex: 0,
      fixed: false,
      currentProduct: {},
      customer: {},
      fixedScroll: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['addToCart', 'removeFromCart', 'alterNum', 'alertSpec', 'alertUnit']), {
    forCustomersChange: function forCustomersChange(e) {
      this.$store.dispatch('setForCustomer', e.currentTarget.value);
      this.$store.dispatch('getAllProducts');
    },
    removeCartNumber: function removeCartNumber(g) {
      if (g.specs && g.specs.length > 1 || g.unit2 && g.priceTransfer) {
        this.specsShow = true;
        this.currentProduct = g;
        var cartGood = this.cartGoods.filter(function (e) {
          return e._id === g._id;
        });
        this.currentSpec = cartGood[0] && cartGood[0].spec;
        this.currentUnit = cartGood[0] && cartGood[0].unit2 || g.unit;
      } else {
        this.removeFromCart(g);
      }
    },
    addCartNumber: function addCartNumber(g) {
      if (g.specs && g.specs.length > 1 || g.unit2 && g.priceTransfer) {
        this.specsShow = true;
        this.currentProduct = g;
        var cartGood = this.cartGoods.filter(function (e) {
          return e._id === g._id;
        });
        this.currentSpec = cartGood[0] && cartGood[0].spec;
        this.currentUnit = cartGood[0] && cartGood[0].unit2 || g.unit;
      } else {
        this.addToCart(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, g, { unit2: this.currentUnit === g.unit ? undefined : g.unit2 }));
      }
    },
    addSpecToCart: function addSpecToCart(g) {
      if (!this.currentSpec && this.currentProduct.specs && this.currentProduct.specs.length > 1) {
        alert('请选择规格');
        return;
      }
      this.addToCart(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, g, { unit2: this.currentUnit === g.unit ? undefined : g.unit2 }));
    },
    removeSpecFromCart: function removeSpecFromCart(g) {
      if (!this.currentSpec && this.currentProduct.specs && this.currentProduct.specs.length > 1) {
        alert('请选择规格');
        return;
      }
      this.removeFromCart(g);
    },
    selectSpec: function selectSpec(spec) {
      this.currentSpec = spec;
      this.currentProduct.spec = spec;
      this.alertSpec(this.currentProduct, spec);
    },
    selectUnit: function selectUnit(unit) {
      this.currentUnit = unit;
      var unit2 = unit === this.currentProduct.unit ? undefined : this.currentProduct.unit2;

      this.alertUnit(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.currentProduct, { unit2: unit2 }));
    },
    checkout: function checkout(products) {
      this.$store.dispatch('checkout', products);
    },
    showSlider: function showSlider(g) {
      var array = [];
      g.images.map(function (e) {
        array.push({ src: e });
      });
      this.slides = array;
      window.history.replaceState({ imageView: true }, '', '');
      window.history.pushState({}, '', '#');
    },
    goBack: function goBack() {
      window.history.go(-1);
    },
    clearSlider: function clearSlider() {
      this.slides = [];
    },
    goCheckout: function goCheckout() {
      if (this.isLogin) {
        this.$router.push('/checkout/');
      } else {
        this.$router.push('/login/');
      }
    },
    clearCart: function clearCart() {
      this.$store.dispatch('clearCart');
      this.cartShow = false;
    },
    toggleCart: function toggleCart() {
      if (this.cartShow) {
        this.cartShow = false;
      } else if (this.cartGoods.length) {
        this.cartShow = true;
      }
    },
    changeCategory: function changeCategory(index, category) {
      this.currentCategoryIndex = index;
      this.$refs[this.categories[index]._id || 'recenty_buy_category'][0].scrollIntoView(true, {
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    },
    handleScroll: function handleScroll() {
      var _this = this;

      var vm = this;
      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.throttle(function () {
        if (vm.$refs.shop.scrollTop >= _this.fixedScroll) {
          vm.fixed = true;
        } else {
          vm.fixed = false;
        }
      }, 50, { trailing: true })();
    },
    goodsScroll: function goodsScroll() {}
  }),

  created: function created() {
    var _this2 = this;

    "production" === 'production' && fetch(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + '/api/redirect' + (this.$route.query.code ? '?code=' + this.$route.query.code : ''), {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'mode': 'no-cors'
      },
      credentials: 'include',
      method: "get"
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.data.redirect) {
        window.location.href = data.data.redirect;
      }
    });
    this.$store.dispatch('getAllProducts');

    this.getLogin().then(function (isLogin) {
      if (isLogin) {
        _this2.$http.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + '/api/customer/info', { withCredentials: true }).then(function (res) {
          _this2.customer = res.data.data;
          if (_this2.customer.isAdmin) {
            _this2.$http.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + '/api/support/customer/list', { withCredentials: true, params: { phone: _this2.customer.phone } }).then(function (res) {
              _this2.forCustomers = res.data.data;
            });
          }
        }).catch(function (e) {
          console.log(e.response.data.message);
        });
      } else {
        _this2.$router.push('/login/');
      }
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    var self = this;

    window.onpopstate = function (event) {
      console.log(event);
      console.log(event.state);
      if (event.state && event.state.imageView) {
        self.clearSlider();
      }
    };
    this.fixedScroll = this.$refs.contentContainer.offsetTop;
  }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_util__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */])()],
  data: function data() {
    return {
      order: {},
      suppliers: [],
      orderFound: 0,
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '已核对',
        3: '已完成'
      }
    };
  },

  computed: {
    address: function address() {
      return this.order && this.order.address || {};
    },
    roughPrice: function roughPrice() {
      var result = 0;
      this.order.products && this.order.products.forEach(function (g) {
        result += Math.round(100 * g.quantity * g.price) / 100;
      });
      return result;
    }
  },

  created: function created() {
    this.getOrder();
  },


  methods: {
    getOrder: function getOrder() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + '/api/inner-order/' + this.$route.params.id).then(function (data) {
        _this.order = data.data.data;
      });
    }
  }

});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */])()],
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '已核对',
        3: '已完成'
      },
      orders: []
    };
  },

  methods: {
    goToDetail: function goToDetail(order) {
      this.$router.push('/supplier/order/' + order._id);
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + ('/api/supplier/' + this.$route.params.id + '/order/list'), { withCredentials: true }).then(function (res) {
      _this.orders = res.data.data;
    });
    this.getLogin().then(function (res) {
      if (!res) {
        _this.$router.push('/login');
      }
    });
  },

  filters: {
    calStatus: function calStatus(val) {
      var res = '';
      switch (val) {
        case "0":
          res = '订单已失效';
          break;
        case "1":
          res = '待支付';
          break;
        case "2":
          res = '支付成功';
          break;
        case "3":
          res = '已取消';
          break;
        case "4":
          res = '订单到付';
          break;
      }
      return res;
    }
  }
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_utils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_util__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mixins_utils__["a" /* default */])()],
  data: function data() {
    return {
      order: {},
      suppliers: [],
      orderFound: 0,
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '已核对',
        3: '已完成'
      }
    };
  },

  computed: {
    address: function address() {
      return this.order && this.order.address || {};
    },
    supplierMap: function supplierMap() {
      var map = {};
      this.suppliers.forEach(function (s) {
        map[s._id] = s.name;
      });
      return map;
    }
  },

  created: function created() {
    this.getOrder();
    this.getSuppliers();
  },


  methods: {
    getSuppliers: function getSuppliers() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + '/api/supplier/list').then(function (res) {
        _this.suppliers = res.data.data;
      });
    },
    getOrder: function getOrder() {
      var _this2 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + '/api/order/' + this.$route.params.id).then(function (res) {
        _this2.order = res.data.data;
      });
    },
    orderConfirm: function orderConfirm() {
      var _this3 = this;

      this.$http.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + '/api/support/order-confirm/' + this.order._id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.order)).then(function (data) {
        _this3.$router.push('/support/orders/');
      });
    },
    cancelOrder: function cancelOrder() {
      var _this4 = this;

      if (confirm('取消订单？')) {
        this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + '/api/order/cancel', { _id: this.order._id }).then(function () {
          _this4.$router.push('/support/orders/');
        });
      }
    }
  }

});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */])()],
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '已核对',
        3: '已完成'
      },
      orders: [],
      suppliers: []
    };
  },

  methods: {
    goToDetail: function goToDetail(order) {
      this.$router.push('/support/order/' + order._id);
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + '/api/support/order/list', { withCredentials: true }).then(function (res) {
      _this.orders = res.data.data;
    });
    this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */] + '/api/supplier/list', { withCredentials: true }).then(function (res) {
      _this.suppliers = res.data.data;
    });
    this.getLogin().then(function (res) {
      if (!res) {
        _this.$router.push('/login');
      }
    });
  },

  computed: {
    supplierMap: function supplierMap() {
      var map = {};
      this.suppliers.forEach(function (s) {
        map[s._id] = s.name;
      });
      return map;
    }
  },
  filters: {
    calStatus: function calStatus(val) {
      var res = '';
      switch (val) {
        case "0":
          res = '订单已失效';
          break;
        case "1":
          res = '待支付';
          break;
        case "2":
          res = '支付成功';
          break;
        case "3":
          res = '已取消';
          break;
        case "4":
          res = '订单到付';
          break;
      }
      return res;
    }
  }
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_Vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(198);








__WEBPACK_IMPORTED_MODULE_2__lib_Vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_2__lib_Vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addToCart", function() { return addToCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alertSpec", function() { return alertSpec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alertUnit", function() { return alertUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFromCart", function() { return removeFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alterNum", function() { return alterNum; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_shop__ = __webpack_require__(62);



var addToCart = function addToCart(_ref, product) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["n" /* ADD_TO_CART */], {
    id: product._id,
    name: product.name,
    spec: product.spec,
    unit: product.unit,
    unit2: product.unit2,
    suppliers: product.suppliers
  });
};

var alertSpec = function alertSpec(_ref2, product) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["m" /* ALTER_SPEC */], {
    id: product._id,
    name: product.name,
    spec: product.spec
  });
};

var alertUnit = function alertUnit(_ref3, product) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["l" /* ALTER_UNIT */], {
    id: product._id,
    name: product.name,
    unit2: product.unit2
  });
};

var removeFromCart = function removeFromCart(_ref4, product) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["o" /* REMOVE_FROME_CART */], {
    id: product._id,
    spec: product.spec
  });
};

var alterNum = function alterNum(_ref5, product) {
  var commit = _ref5.commit;

  var num = event.target.value;
  num = Math.floor(num);
  if (num < 0) {
    num = 0;
  }
  if (num > 999) {
    num = 999;
  }
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["p" /* ALTER_NUM */], {
    id: product._id,
    spec: product.spec,
    num: num
  });
};

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cartProducts", function() { return cartProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productCartNum", function() { return productCartNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productCartTotalNum", function() { return productCartTotalNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "totalPrice", function() { return totalPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkoutStatus", function() { return checkoutStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allAddresses", function() { return allAddresses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forCustomer", function() { return forCustomer; });
var cartProducts = function cartProducts(state) {
	var result = [];
	state.cart.added.map(function (_ref) {
		var _id = _ref._id,
		    quantity = _ref.quantity,
		    spec = _ref.spec,
		    _ref$unit = _ref.unit,
		    unit = _ref$unit === undefined ? '斤' : _ref$unit,
		    unit2 = _ref.unit2;

		var product = state.products.all.find(function (p) {
			return p._id === _id;
		});
		if (product) {
			result.push({
				name: product.name,
				price: product.customerPrice || product.price,
				priceTransfer: product.priceTransfer,
				quantity: unit2 ? quantity * product.priceTransfer : quantity,
				spec: spec,
				unit: unit,
				unit2: unit2,
				_id: _id,
				suppliers: product.suppliers
			});
		}
	});
	result.sort(function (a, b) {
		return a.name.localeCompare(b.name);
	});
	return result;
};

var productCartNum = function productCartNum(state) {
	var map = {};

	state.cart.added.map(function (_ref2) {
		var _id = _ref2._id,
		    quantity = _ref2.quantity,
		    spec = _ref2.spec;

		if (!map[_id]) {
			map[_id] = quantity;
		} else {
			map[_id] += quantity;
		}

		if (spec) {
			map[_id + spec] = quantity;
		}
	});
	state.products.all.map(function (product) {
		if (!map[product._id]) {
			map[product._id] = 0;
		}
	});
	return map;
};

var productCartTotalNum = function productCartTotalNum(state) {
	var total = 0;
	state.cart.added.map(function (_ref3) {
		var quantity = _ref3.quantity;

		total += quantity;
	});

	return total;
};

var totalPrice = function totalPrice(state) {
	var total = 0;
	state.cart.added.map(function (_ref4) {
		var _id = _ref4._id,
		    quantity = _ref4.quantity,
		    unit2 = _ref4.unit2;

		var product = state.products.all.find(function (p) {
			return p._id === _id;
		});
		product && (total += (product.unit2 && unit2 && product.priceTransfer || 1) * (product.customerPrice || product.price) * quantity);
	});
	return Math.round(total * 100) / 100;
};

var checkoutStatus = function checkoutStatus(state) {
	return state.cart.checkoutStatus;
};

var allAddresses = function allAddresses(state) {
	return state.addresses.addresses;
};

var forCustomer = function forCustomer(state) {
	return state.products.forCustomer;
};

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_shop__ = __webpack_require__(62);



var _mutations;




var state = {
  address: {}
};

var getters = {
  myAddress: function myAddress(state) {
    return state.address || {};
  }
};

var actions = {
  getMyAddresses: function getMyAddresses(_ref, forCustomer) {
    var commit = _ref.commit,
        state = _ref.state;

    __WEBPACK_IMPORTED_MODULE_3__api_shop__["a" /* default */].getAddresses(forCustomer, function (address) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_ADDRESSES */], { address: address });
    });
  },
  saveAddress: function saveAddress(_ref2, _ref3) {
    var commit = _ref2.commit,
        state = _ref2.state;
    var newAddress = _ref3.address,
        forCustomer = _ref3.forCustomer;
    var phone = newAddress.phone,
        contact = newAddress.contact,
        address = newAddress.address;

    __WEBPACK_IMPORTED_MODULE_3__api_shop__["a" /* default */].newAddress(forCustomer, { tel: phone, name: contact, street: address }, function (address) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* NEW_ADDRESSES */], address);
    });
  },
  editAddress: function editAddress(_ref4, _ref5) {
    var commit = _ref4.commit,
        state = _ref4.state;
    var newAddress = _ref5.address,
        forCustomer = _ref5.forCustomer;
    var phone = newAddress.phone,
        contact = newAddress.contact,
        address = newAddress.address,
        _id = newAddress._id;

    __WEBPACK_IMPORTED_MODULE_3__api_shop__["a" /* default */].editAddress(forCustomer, { tel: phone, name: contact, street: address, _id: _id }, function (address) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* EDIT_ADDRESSES */], address);
    });
  },
  updateAddress: function updateAddress(_ref6, _ref7) {
    var commit = _ref6.commit,
        state = _ref6.state;
    var phone = _ref7.phone,
        contact = _ref7.contact,
        address = _ref7.address;

    var address1 = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.address));
    address1.attributes.line_1 = contact;
    address1.attributes.line_2 = phone;
    address1.attributes.line_3 = address;
    __WEBPACK_IMPORTED_MODULE_3__api_shop__["a" /* default */].updateAddresses(address1[0]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_ADDRESSES */], function (state, address) {
  state.address = address.address;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* NEW_ADDRESSES */], function (state, address) {
  state.address = address;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* EDIT_ADDRESSES */], function (state, address) {
  state.address = address;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_Vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_shop__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(63);




var _mutations;





var STORAGE_KEY = 'roupoo-cart';

var state = {
  added: JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]'),
  checkoutStatus: null
};

var getters = {
  cartCheckoutStatus: function cartCheckoutStatus(state) {
    return state.checkoutStatus;
  }
};

var actions = {
  checkout: function checkout(_ref, _ref2) {
    var commit = _ref.commit,
        state = _ref.state;
    var forCustomer = _ref2.forCustomer,
        order = _ref2.order;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var savedCartItems = Array.prototype.slice.call([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.added)));

      __WEBPACK_IMPORTED_MODULE_4__api_shop__["a" /* default */].buyProducts(forCustomer, order, function (response) {
        resolve(response);
      }, function () {
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* CHECKOUT_FAILURE */], { savedCartItems: savedCartItems });
        reject('error');
      });
    });
  },
  clearCart: function clearCart(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* CLEAR_CART */]);
  },
  checkoutSuccess: function checkoutSuccess(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["k" /* CHECKOUT_SUCCESS */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* ALTER_UNIT */], function (state, _ref5) {
  var id = _ref5.id,
      unit2 = _ref5.unit2;

  var record = state.added.find(function (p) {
    return p._id === id;
  });
  if (record) {
    __WEBPACK_IMPORTED_MODULE_3__lib_Vue__["a" /* default */].set(record, 'unit2', unit2);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* ALTER_SPEC */], function (state, _ref6) {
  var id = _ref6.id,
      spec = _ref6.spec;

  var record = state.added.find(function (p) {
    return p._id === id;
  });
  if (record) {
    record.spec = spec;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["n" /* ADD_TO_CART */], function (state, _ref7) {
  var id = _ref7.id,
      name = _ref7.name,
      spec = _ref7.spec,
      unit = _ref7.unit,
      unit2 = _ref7.unit2;

  var record = state.added.find(function (p) {
    return p._id === id;
  });
  if (!record) {
    state.added.push({
      _id: id,
      name: name,
      spec: spec,
      quantity: 1,
      unit: unit,
      unit2: unit2
    });
  } else {
    if (record.quantity < 999) {
      record.quantity++;
      record.spec = spec;
      record.unit2 = unit2;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* CLEAR_CART */], function (state) {
  state.added = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["o" /* REMOVE_FROME_CART */], function (state, _ref8) {
  var id = _ref8.id,
      spec = _ref8.spec;

  var record = state.added.find(function (p) {
    return p._id === id;
  });
  if (!record || record.quantity == 0) return;
  record.quantity--;
  record.spec = spec;
  if (record.quantity == 0) {
    state.added.splice(state.added.indexOf(record), 1);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["p" /* ALTER_NUM */], function (state, _ref9) {
  var id = _ref9.id,
      num = _ref9.num,
      spec = _ref9.spec;

  var record = state.added.find(function (p) {
    return p._id === id;
  });
  if (!record || record.quantity == 0) return;
  record.quantity = num;
  record.spec = spec;
  if (record.quantity <= 0) {
    state.added.splice(state.added.indexOf(record), 1);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["q" /* CHECKOUT_REQUEST */], function (state) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["k" /* CHECKOUT_SUCCESS */], function (state) {
  state.checkoutStatus = 'successful';
  state.added = [];
  state.checkoutStatus = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* CHECKOUT_FAILURE */], function (state, _ref10) {
  var savedCartItems = _ref10.savedCartItems;

  state.added = savedCartItems;
  state.checkoutStatus = 'failed';
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(12);

var state = {
  config: {
    host: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* host */]
  }
};

var getters = {
  config: function config(state) {
    return state.config;
  }
};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_shop__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(63);


var _mutations;




var state = {
  all: [],
  currentId: 0
};

var getters = {
  allOrders: function allOrders(state) {
    return state.all;
  },
  currentOrderId: function currentOrderId(state) {
    return state.currentId;
  }
};

var actions = {
  getAllOrders: function getAllOrders(_ref, cb) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_shop__["a" /* default */].getOrders(function (orders) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* GET_ORDERS */], { orders: orders });
      cb && cb();
    });
  },
  setCurrentId: function setCurrentId(_ref2, currentId) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_ORDER_ID */], currentId);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* GET_ORDERS */], function (state, _ref3) {
  var orders = _ref3.orders;

  state.all = orders;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_ORDER_ID */], function (state, _ref4) {
  var currentId = _ref4.currentId;

  state.currentId = currentId;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_shop__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(63);


var _mutations;




var state = {
  all: [],
  categories: [],
  forCustomer: ''
};

var getters = {
  allProducts: function allProducts(state) {
    return state.all;
  },
  categories: function categories(state) {
    return state.categories;
  }
};

var actions = {
  getAllProducts: function getAllProducts(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    __WEBPACK_IMPORTED_MODULE_1__api_shop__["a" /* default */].getProducts(state.forCustomer, function (data) {
      var products = [];
      data.data.forEach(function (e) {
        products = products.concat(e.products);
      });
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* RECEIVE_PRODUCTS */], { products: products });
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* RECEIVE_CATEGORIES */], { categories: data.data });
    });
  },
  setForCustomer: function setForCustomer(_ref2, forCustomer) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* SET_FOR_CUSTOMER */], { forCustomer: forCustomer });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* RECEIVE_PRODUCTS */], function (state, _ref3) {
  var products = _ref3.products;

  state.all = products;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* RECEIVE_CATEGORIES */], function (state, _ref4) {
  var categories = _ref4.categories;

  state.categories = categories;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* SET_FOR_CUSTOMER */], function (state, _ref5) {
  var forCustomer = _ref5.forCustomer;

  state.forCustomer = forCustomer;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var STORAGE_KEY = 'roupoo-cart';
var localStoragePlugin = function localStoragePlugin(store) {
  store.subscribe(function (mutation, state) {
    window.localStorage.setItem(STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.cart.added));
  });
};

/* harmony default export */ __webpack_exports__["a"] = ([localStoragePlugin]);

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = utils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dateformat__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dateformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(12);





function utils() {
  return {
    data: function data() {
      return {
        isLogin: false
      };
    },

    methods: {
      getLogin: function getLogin() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt('return', _this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* host */] + '/api/customer/is_login', { withCredentials: true }).then(function (res) {
                    _this.isLogin = res.data.data;
                    return _this.isLogin;
                  }).catch(function (e) {}));

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      }
    },
    destroyed: function destroyed() {},


    filters: {
      filterTime: function filterTime(val) {
        return __WEBPACK_IMPORTED_MODULE_2_dateformat___default()(new Date(val), "yyyy-mm-dd HH:MM:ss");
      },
      safeNum: function safeNum(num) {
        return Math.round(num * 100) / 100;
      }
    }
  };
}

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(494)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  "data-v-285b0d82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(498)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  "data-v-4ee982ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  "data-v-6fb39f5d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(544),
  /* scopeId */
  "data-v-72e68da8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(491)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  "data-v-01c44c14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  "data-v-46e36404",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(547),
  /* scopeId */
  "data-v-7a60ca18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  "data-v-63c3e113",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  "data-v-b19aed8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(495)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  "data-v-300ff3ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(548),
  /* scopeId */
  "data-v-99add748",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(492)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  "data-v-0e34911e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  "data-v-4fc88454",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(496)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  "data-v-412cf1f5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(493)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  "data-v-23e1f29f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 533:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(!_vm.order && _vm.orderFound) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    抱歉，没有查到相关订单\n  ")]) : _vm._e(), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "checkout"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('i', {
    staticClass: "pos-icon"
  }), _vm._v(" "), (_vm.address.name) ? _c('div', {
    staticClass: "address-info"
  }, [_c('p', {
    staticClass: "user"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.address.name))]), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_vm._v(_vm._s(_vm.address.tel))])]), _vm._v(" "), _c('p', {
    staticClass: "street"
  }, [_vm._v("\n          " + _vm._s(_vm.address.street) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('ul', {}, _vm._l((_vm.order.products), function(g) {
    return _c('li', {
      key: g.name + g.spec
    }, [_c('p', {
      staticClass: "cart-item"
    }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("(" + _vm._s(g.quantity / (Number((g.unit2 && g.priceTransfer || 1)))) + _vm._s(g.unit2 || '份') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "quantity"
    }, [_vm._v("    " + _vm._s(g.quantity) + _vm._s(g.unit || '斤'))]), _vm._v(" "), (g.suppliers && g.suppliers[0] && g.suppliers[0] !== _vm.order.supplier) ? _c('span', {
      staticStyle: {
        "float": "right",
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.supplierMap[g.suppliers[0]]))]) : _vm._e()])])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "total-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("总计")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥" + _vm._s(_vm.roughPrice))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送时间")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.dueTime))])]), _vm._v(" "), (_vm.order.notes) ? _c('div', {
    staticClass: "order-notes"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单备注")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.notes))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order._id))])]), _vm._v(" "), (_vm.order.createTime) ? _c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("filterTime")(_vm.order.createTime)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-status-band"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.STATUS_MAP[_vm.order.status]))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delivery-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送费")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥0")])])
}]}

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(!_vm.order && _vm.orderFound) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    抱歉，没有查到相关订单\n  ")]) : _vm._e(), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "checkout"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('i', {
    staticClass: "pos-icon"
  }), _vm._v(" "), (_vm.address.name) ? _c('div', {
    staticClass: "address-info"
  }, [_c('p', {
    staticClass: "user"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.address.name))]), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_vm._v(_vm._s(_vm.address.tel))])]), _vm._v(" "), _c('p', {
    staticClass: "street"
  }, [_vm._v("\n          " + _vm._s(_vm.address.street) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('ul', {}, _vm._l((_vm.order.products), function(g) {
    return _c('li', {
      key: g.name + g.spec
    }, [_c('p', {
      staticClass: "cart-item"
    }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("(" + _vm._s(g.quantity / (Number((g.unit2 && g.priceTransfer || 1)))) + _vm._s(g.unit2 || '份') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "quantity"
    }, [_vm._v(_vm._s(g.quantity) + _vm._s(g.unit || '斤'))])])])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "total-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("总计")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥" + _vm._s(_vm.roughPrice))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送时间")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.dueTime))])]), _vm._v(" "), (_vm.order.notes) ? _c('div', {
    staticClass: "order-notes"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单备注")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.notes))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order._id))])]), _vm._v(" "), (_vm.order.createTime) ? _c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("filterTime")(_vm.order.createTime)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-status-band"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.STATUS_MAP[_vm.order.status]))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delivery-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送费")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥0")])])
}]}

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-list"
  }, [(!_vm.orders.length) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    您暂时没有订单！\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order._id,
      staticClass: "order-item",
      on: {
        "click": function($event) {
          return _vm.goToDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "order-no"
    }, [_c('span', {
      staticClass: "order-name"
    }, [_vm._v("订单编号：" + _vm._s(order._id))]), _vm._v(" "), _c('span', {
      staticClass: "order-status"
    }, [_vm._v(_vm._s(_vm._f("calStatus")(order.status)))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-item"
    }, [_c('ul', _vm._l((order.products), function(g, index) {
      return _c('li', {
        key: g._id + index
      }, [_c('p', {
        staticClass: "cart-item"
      }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), _c('span', {
        staticClass: "quantity"
      }, [_vm._v("    " + _vm._s(g.quantity / Number((g.unit2 && g.priceTransfer || 1))) + _vm._s(g.unit2 || g.unit || '斤'))]), _vm._v(" "), (g.suppliers && g.suppliers[0] && g.suppliers[0] !== order.supplier._id) ? _c('span', {
        staticStyle: {
          "float": "right",
          "color": "red"
        }
      }, [_vm._v(_vm._s(_vm.supplierMap[g.suppliers[0]]))]) : _vm._e()])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "total-price"
    }, [_c('span', {
      staticClass: "created_time"
    }, [_vm._v(_vm._s(_vm._f("filterTime")(order.createTime)))]), _vm._v(" "), _c('span', {
      style: ({
        color: order.status !== 1 ? 'red' : '#666'
      })
    }, [_vm._v("总计：¥" + _vm._s(_vm._f("safeNum")(order.roughPrice)) + " | " + _vm._s(_vm.STATUS_MAP[order.status]))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', [_vm._v("备注：" + _vm._s(order.notes))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', {
      staticClass: "customer"
    }, [_vm._v("客户：" + _vm._s(order.customer && order.customer.name))]), _vm._v(" "), _c('span', {
      staticClass: "supplier"
    }, [_vm._v("供应商：" + _vm._s(order.supplier && order.supplier.name || '暂无'))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', [_vm._v("下单人：" + _vm._s(order.placedBy.name) + _vm._s(" " + order.placedBy.phone))])])])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact),
      expression: "contact"
    }],
    staticClass: "contact",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "tel",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item address-item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("地址")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "address-value",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "save-address"
  }, [_c('input', {
    staticClass: "save-btn",
    class: {
      'btn-disable': _vm.checkValid()
    },
    attrs: {
      "type": "button",
      "value": "保存"
    },
    on: {
      "click": function($event) {
        return _vm.saveAddress()
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-list"
  }, [(!_vm.orders.length) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    您暂时没有订单！\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order._id,
      staticClass: "order-item",
      on: {
        "click": function($event) {
          return _vm.goToDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "order-no"
    }, [_c('span', {
      staticClass: "order-name"
    }, [_vm._v("订单编号：" + _vm._s(order._id))]), _vm._v(" "), _c('span', {
      staticClass: "order-status"
    }, [_vm._v(_vm._s(_vm._f("calStatus")(order.status)))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-item"
    }, [_c('ul', [_vm._l((order.products), function(g, index) {
      return _c('li', {
        key: g._id + index
      }, [(index < 3) ? _c('p', {
        staticClass: "cart-item"
      }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v("(" + _vm._s(g.quantity / (Number((g.unit2 && g.priceTransfer || 1)))) + _vm._s(g.unit2 || '份') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "quantity"
      }, [_vm._v("    " + _vm._s(g.quantity) + _vm._s(g.unit || '斤'))])]) : _vm._e()])
    }), _vm._v(" "), (order.products && order.products.length >= 3) ? _c('li', {
      staticStyle: {
        "height": ".7rem",
        "margin-top": "-0.2rem"
      }
    }, [_vm._v("...")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "total-price"
    }, [_c('span', {
      staticClass: "created_time"
    }, [_vm._v(_vm._s(_vm._f("filterTime")(order.createTime)))]), _vm._v(" "), _c('span', [_vm._v("总计：¥" + _vm._s(order.roughPrice) + " | " + _vm._s(_vm.STATUS_MAP[order.status]))])]), _vm._v(" "), (_vm.customer.isAdmin) ? _c('div', {
      staticClass: "order-info"
    }, [_c('span', {
      staticClass: "customer"
    }, [_vm._v("客户：" + _vm._s(order.customer && order.customer.name))]), _vm._v(" "), _c('span', {
      staticClass: "supplier"
    }, [_vm._v("供应商：" + _vm._s(order.supplier && order.supplier.name || '暂无'))])]) : _vm._e()])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(!_vm.order && _vm.orderFound) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    抱歉，没有查到相关订单\n  ")]) : _vm._e(), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "checkout"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('i', {
    staticClass: "pos-icon"
  }), _vm._v(" "), (_vm.address.name) ? _c('div', {
    staticClass: "address-info"
  }, [_c('p', {
    staticClass: "user"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.address.name))]), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_vm._v(_vm._s(_vm.address.tel))])]), _vm._v(" "), _c('p', {
    staticClass: "street"
  }, [_vm._v("\n          " + _vm._s(_vm.address.street) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('ul', {}, _vm._l((_vm.order.products), function(g) {
    return _c('li', {
      key: g.name + g.spec
    }, [_c('p', {
      staticClass: "cart-item"
    }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("(" + _vm._s(g.quantity / (Number((g.unit2 && g.priceTransfer || 1)))) + _vm._s(g.unit2 || '份') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(g.unit || '斤'))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (g.quantity),
        expression: "g.quantity"
      }],
      staticClass: "quantity",
      domProps: {
        "value": (g.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(g, "quantity", $event.target.value)
        }
      }
    }), _vm._v(" "), (g.suppliers && g.suppliers[0] && g.suppliers[0] !== _vm.order.supplier) ? _c('span', {
      staticStyle: {
        "float": "right",
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.supplierMap[g.suppliers[0]]))]) : _vm._e()])])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "total-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("总计")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥" + _vm._s(_vm.order.roughPrice))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送时间")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.dueTime))])]), _vm._v(" "), (_vm.order.notes) ? _c('div', {
    staticClass: "order-notes"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单备注")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.notes))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order._id))])]), _vm._v(" "), (_vm.order.createTime) ? _c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("filterTime")(_vm.order.createTime)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-status-band"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.STATUS_MAP[_vm.order.status]))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-status-band"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("供应商")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.supplier),
      expression: "order.supplier"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.order, "supplier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.suppliers), function(supplier) {
    return _c('option', {
      key: supplier._id,
      domProps: {
        "value": supplier._id
      }
    }, [_vm._v(_vm._s(supplier.name))])
  })], 2)])])]), _vm._v(" "), (_vm.order.status == 2 || _vm.order.status == 1) ? _c('div', {
    staticClass: "bottom-options"
  }, [(_vm.order.status == 1) ? _c('p', {
    staticClass: "order-to-pay"
  }, [_c('span', {
    staticClass: "pay",
    on: {
      "click": function($event) {
        return _vm.orderConfirm()
      }
    }
  }, [_vm._v("确认提交")])]) : _vm._e(), _vm._v(" "), (_vm.order.status == 2) ? _c('p', {
    staticClass: "order-to-pay"
  }, [_c('span', {
    staticClass: "pay",
    on: {
      "click": function($event) {
        return _vm.orderConfirm()
      }
    }
  }, [_vm._v("再次确认")])]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delivery-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送费")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥0")])])
}]}

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-list"
  }, [(!_vm.orders.length) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    暂时没有订单！\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order._id,
      staticClass: "order-item",
      on: {
        "click": function($event) {
          return _vm.goToDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "order-no"
    }, [_c('span', {
      staticClass: "order-name"
    }, [_vm._v("订单编号：" + _vm._s(order._id))]), _vm._v(" "), _c('span', {
      staticClass: "order-status"
    }, [_vm._v(_vm._s(_vm._f("calStatus")(order.status)))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-item"
    }, [_c('ul', _vm._l((order.products), function(g, index) {
      return _c('li', {
        key: g._id + index
      }, [_c('p', {
        staticClass: "cart-item"
      }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v("(" + _vm._s(g.quantity / (Number((g.unit2 && g.priceTransfer || 1)))) + _vm._s(g.unit2 || '份') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "quantity"
      }, [_vm._v("    " + _vm._s(g.quantity) + _vm._s(g.unit || '斤'))]), _vm._v(" "), (g.suppliers && g.suppliers[0] && g.suppliers[0] !== order.supplier._id) ? _c('span', {
        staticStyle: {
          "float": "right",
          "color": "red"
        }
      }, [_vm._v(_vm._s(_vm.supplierMap[g.suppliers[0]]))]) : _vm._e()])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "total-price"
    }, [_c('span', {
      staticClass: "created_time"
    }, [_vm._v(_vm._s(_vm._f("filterTime")(order.createTime)))]), _vm._v(" "), _c('span', [_vm._v("总计：¥" + _vm._s(order.roughPrice) + " | " + _vm._s(_vm.STATUS_MAP[order.status]))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', [_vm._v("备注：" + _vm._s(order.notes))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', {
      staticClass: "customer"
    }, [_vm._v("客户：" + _vm._s(order.customer.name))]), _vm._v(" "), _c('span', {
      staticClass: "supplier"
    }, [_vm._v("供应商：" + _vm._s(order.supplier && order.supplier.name))])])])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "checkout"
  }, [_c('div', {
    staticClass: "address",
    on: {
      "click": function($event) {
        return _vm.goToAddressList()
      }
    }
  }, [_c('i', {
    staticClass: "pos-icon"
  }), _vm._v(" "), (_vm.address && _vm.address.name) ? _c('div', {
    staticClass: "address-info"
  }, [_c('p', {
    staticClass: "user"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.address.name))]), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_vm._v(_vm._s(_vm.address.tel))])]), _vm._v(" "), _c('p', {
    staticClass: "street"
  }, [_vm._v("\n          " + _vm._s(_vm.address.street) + "\n        ")])]) : _vm._e(), _vm._v(" "), (!_vm.address || !_vm.address.name) ? _c('div', {
    staticClass: "address-info"
  }, [_c('p', {
    staticClass: "user"
  }, [_vm._v("\n          添加地址\n        ")])]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "more-icon"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('ul', {}, _vm._l((_vm.cartGoods), function(g) {
    return _c('li', {
      key: g.name + g.spec
    }, [_c('p', {
      staticClass: "cart-item"
    }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(Math.round(g.quantity * (g.customerPrice || g.price) * 100) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("(约" + _vm._s(Number(g.quantity).toFixed(2)) + _vm._s(g.unit || '斤') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "quantity"
    }, [_vm._v(_vm._s(g.quantity / Number((g.unit2 && g.priceTransfer || 1))) + _vm._s(g.unit2 || g.unit || '斤'))])])])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "total-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("总计")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥" + _vm._s(_vm.totalPrice))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送时间")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryTime),
      expression: "deliveryTime"
    }],
    attrs: {
      "name": "",
      "id": "time-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deliveryTime = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "明天10:00-11:00"
    }
  }, [_vm._v("明天10:00-11:00")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "明天9:00-10:00"
    }
  }, [_vm._v("明天9:00-10:00")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "明天8:00-9:00"
    }
  }, [_vm._v("明天8:00-9:00")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "明天7:00-8:00",
      "selected": "selected"
    }
  }, [_vm._v("明天7:00-8:00")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "明天6:00-7:00"
    }
  }, [_vm._v("明天6:00-7:00")])]), _vm._v(" "), _c('i', {
    staticClass: "more-select"
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-notes"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单备注")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    attrs: {
      "placeholder": "补充说明",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-options"
  }, [_c('p', {
    staticClass: "total"
  }, [_c('span', {
    staticClass: "total-name"
  }, [_vm._v("预估金额：")]), _c('span', {
    staticClass: "price"
  }, [_vm._v("¥" + _vm._s(_vm.totalPrice))])]), _vm._v(" "), _c('button', {
    staticClass: "place-order",
    attrs: {
      "disabled": _vm.placingOrder
    },
    on: {
      "click": function($event) {
        return _vm.placeOrder()
      }
    }
  }, [_vm._v("\n          提交订单\n      ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delivery-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送费")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥0")])])
}]}

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-list"
  }, [(!_vm.orders.length) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    暂时没有订单！\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order._id,
      staticClass: "order-item",
      on: {
        "click": function($event) {
          return _vm.goToDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "order-no"
    }, [_c('span', {
      staticClass: "order-name"
    }, [_vm._v("订单编号：" + _vm._s(order._id))]), _vm._v(" "), _c('span', {
      staticClass: "order-status"
    }, [_vm._v(_vm._s(_vm._f("calStatus")(order.status)))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-item"
    }, [_c('ul', _vm._l((order.products), function(g, index) {
      return _c('li', {
        key: g._id + index
      }, [_c('p', {
        staticClass: "cart-item"
      }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v("(" + _vm._s(g.quantity / (Number((g.unit2 && g.priceTransfer || 1)))) + _vm._s(g.unit2 || '份') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "quantity"
      }, [_vm._v("    " + _vm._s(g.quantity) + _vm._s(g.unit || '斤'))])])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "total-price"
    }, [_c('span', {
      staticClass: "created_time"
    }, [_vm._v(_vm._s(_vm._f("filterTime")(order.createTime)))]), _vm._v(" "), _c('span', {
      style: ({
        color: order.status !== 1 ? 'red' : '#666'
      })
    }, [_vm._v("总计：¥" + _vm._s(_vm._f("safeNum")(order.roughPrice)) + " | " + _vm._s(_vm.STATUS_MAP[order.status]))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', [_vm._v("备注：" + _vm._s(order.notes))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', {
      staticClass: "customer"
    }, [_vm._v("客户：" + _vm._s(order.customer && order.customer.name))]), _vm._v(" "), _c('span', {
      staticClass: "customer",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v("送货员：" + _vm._s(order.delivery && order.delivery.name))])])])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "phone",
    attrs: {
      "type": "text",
      "placeholder": "请输入店铺名称"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("您尚未提交您的店铺名称")]), _vm._v(" "), _c('button', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("确认")])])
},staticRenderFns: []}

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(!_vm.order && _vm.orderFound) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    抱歉，没有查到相关订单\n  ")]) : _vm._e(), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "checkout"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('i', {
    staticClass: "pos-icon"
  }), _vm._v(" "), (_vm.address.name) ? _c('div', {
    staticClass: "address-info"
  }, [_c('p', {
    staticClass: "user"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.address.name))]), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_vm._v(_vm._s(_vm.address.tel))])]), _vm._v(" "), _c('p', {
    staticClass: "street"
  }, [_vm._v("\n          " + _vm._s(_vm.address.street) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('ul', {}, _vm._l((_vm.order.products), function(g) {
    return _c('li', {
      key: g.name + g.spec
    }, [_c('p', {
      staticClass: "cart-item"
    }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("(" + _vm._s(g.quantity / (Number((g.unit2 && g.priceTransfer || 1)))) + _vm._s(g.unit2 || '份') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "quantity"
    }, [_vm._v("    " + _vm._s(g.quantity) + _vm._s(g.unit || '斤'))])])])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "total-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("总计")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥" + _vm._s(_vm.order.roughPrice))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送时间")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.dueTime))])]), _vm._v(" "), (_vm.order.notes) ? _c('div', {
    staticClass: "order-notes"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单备注")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.notes))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "delivery-time"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order._id))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-status-band"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.STATUS_MAP[_vm.order.status]))])])]), _vm._v(" "), (_vm.order.status == 1 || _vm.order.status == 2) ? _c('div', {
    staticClass: "bottom-options"
  }, [(_vm.order.status == 1) ? _c('p', {
    staticClass: "order-status"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancelOrder()
      }
    }
  }, [_vm._v("取消订单")])]) : _vm._e(), _vm._v(" "), (_vm.order.status == 2) ? _c('p', {
    staticClass: "order-to-pay"
  }, [_c('span', {
    staticClass: "pay",
    on: {
      "click": function($event) {
        return _vm.orderPrePay()
      }
    }
  }, [_vm._v("马上付款")])]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delivery-fee"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("配送费")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("¥0")])])
}]}

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-success"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "words"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('p', {
    staticClass: "return-home"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goToHome()
      }
    }
  }, [_vm._v("返回首页")])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "success-icon"
  }, [_c('i')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('p', [_vm._v("\n      如有问题任何请联系客服\n    ")]), _vm._v(" "), _c('p', [_vm._v("客服电话: 17621085394")])])
}]}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "wrapper"
  }, [_c('div', {
    ref: "shop",
    staticClass: "shop",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.slides && _vm.slides.length) ? _c('div', {
    staticClass: "shadow",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('slider', {
    attrs: {
      "slides": _vm.slides
    },
    on: {
      "on-img-tap": function($event) {
        return _vm.goBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "banner",
    staticClass: "banner"
  }), _vm._v(" "), (_vm.customer.isAdmin) ? _c('div', {
    staticClass: "for-customers"
  }, [_c('span', [_vm._v("服务用户：")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.forCustomer
    },
    on: {
      "change": _vm.forCustomersChange
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.forCustomers), function(forCustomer) {
    return _c('option', {
      key: forCustomer._id,
      domProps: {
        "value": forCustomer._id
      }
    }, [_vm._v(_vm._s(forCustomer.name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "contentContainer",
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "categories",
    class: {
      'fixed': _vm.fixed
    }
  }, [_c('ul', _vm._l((_vm.categories), function(category, index) {
    return _c('li', {
      key: category._id,
      class: {
        'selected': index == _vm.currentCategoryIndex
      },
      on: {
        "click": function($event) {
          return _vm.changeCategory(index, category)
        }
      }
    }, [_vm._v(_vm._s(category.name))])
  }), 0)]), _vm._v(" "), _c('ul', {
    ref: "goodsList",
    staticClass: "goods-list",
    on: {
      "scroll": _vm.goodsScroll
    }
  }, [_vm._l((_vm.categories), function(category) {
    return [_c('li', {
      ref: category._id || 'recenty_buy_category',
      refInFor: true,
      staticClass: "category-name"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _vm._l((category.products), function(g) {
      return _c('li', [_c('div', {
        staticClass: "goods-container"
      }, [_c('img', {
        attrs: {
          "src": g.images[0]
        },
        on: {
          "click": function($event) {
            return _vm.showSlider(g)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "goods-info"
      }, [_c('p', [_c('span', {
        staticClass: "goods-name"
      }, [_vm._v(_vm._s(g.name))])]), _vm._v(" "), _c('p', [_c('span', {
        staticClass: "goods-desc"
      }, [_vm._v(_vm._s(g.desc))])]), _vm._v(" "), _c('p', [_c('span', {
        staticClass: "goods-price"
      }, [_vm._v("¥" + _vm._s(Number(g.customerPrice || g.price).toFixed(1)))]), _c('span', {
        staticClass: "price-unit"
      }, [_vm._v("元/" + _vm._s(g.unit || '斤'))]), _vm._v(" "), _c('span', {
        staticClass: "count-btn add-btn",
        on: {
          "click": function($event) {
            return _vm.addCartNumber(g)
          }
        }
      }, [_vm._v("+")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.productCartNum[g._id]),
          expression: "productCartNum[g._id]"
        }],
        staticClass: "count-num",
        style: ({
          visibility: _vm.productCartNum[g._id] ? 'visible' : 'hidden'
        }),
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (_vm.productCartNum[g._id])
        },
        on: {
          "change": function($event) {
            return _vm.alterNum(g, $event)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.productCartNum, g._id, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "count-btn minus-btn",
        style: ({
          visibility: _vm.productCartNum[g._id] ? 'visible' : 'hidden'
        }),
        on: {
          "click": function($event) {
            return _vm.removeCartNumber(g)
          }
        }
      }, [_vm._v("-")])])])])])
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartShow),
      expression: "cartShow"
    }],
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('span', {
    staticClass: "clear-goods",
    on: {
      "click": function($event) {
        return _vm.clearCart()
      }
    }
  }, [_c('i'), _vm._v("清空")])]), _vm._v(" "), _c('ul', _vm._l((_vm.cartGoods), function(g) {
    return _c('li', {
      key: g.id
    }, [_c('p', {
      staticClass: "cart-item"
    }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(Math.round(g.quantity * g.price * 100) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("(约" + _vm._s(Number(g.quantity).toFixed(2)) + _vm._s(g.unit || '斤') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("    " + _vm._s(parseInt(g.quantity / (g.unit2 ? g.priceTransfer : 1))) + _vm._s(g.unit2 || g.unit || '斤'))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartShow),
      expression: "cartShow"
    }],
    staticClass: "masker",
    on: {
      "click": function($event) {
        _vm.cartShow = false;
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.specsShow),
      expression: "specsShow"
    }],
    staticClass: "masker",
    on: {
      "click": function($event) {
        _vm.specsShow = false;
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "time-masker"
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.specsShow),
      expression: "specsShow"
    }],
    staticClass: "specs"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.currentProduct.name))]), _vm._v(" "), (_vm.currentProduct.unit2 && _vm.currentProduct.priceTransfer) ? _c('ul', {
    staticClass: "item-container"
  }, [_c('li', {
    staticClass: "item-title"
  }, [_vm._v("单位")]), _vm._v(" "), _c('li', {
    staticClass: "item",
    class: {
      'selected': _vm.currentProduct.unit2 !== _vm.currentUnit
    },
    on: {
      "click": function($event) {
        return _vm.selectUnit(_vm.currentProduct.unit)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currentProduct.unit) + "\n      ")]), _vm._v(" "), _c('li', {
    staticClass: "item",
    class: {
      'selected': _vm.currentProduct.unit2 === _vm.currentUnit
    },
    on: {
      "click": function($event) {
        return _vm.selectUnit(_vm.currentProduct.unit2)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currentProduct.unit2) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.currentProduct.specs && _vm.currentProduct.specs.length > 1) ? _c('ul', {
    staticClass: "item-container"
  }, [_c('li', {
    staticClass: "item-title"
  }, [_vm._v("规格")]), _vm._v(" "), _vm._l((_vm.currentProduct.specs), function(spec) {
    return _c('li', {
      key: spec,
      staticClass: "item",
      class: {
        'selected': spec === _vm.currentSpec
      },
      on: {
        "click": function($event) {
          return _vm.selectSpec(spec)
        }
      }
    }, [_vm._v("\n        " + _vm._s(spec) + "\n      ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-row"
  }, [_c('div', {
    staticClass: "button-container"
  }, [_c('span', {
    staticClass: "count-btn add-btn",
    on: {
      "click": function($event) {
        return _vm.addSpecToCart(_vm.currentProduct)
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCartNum[_vm.currentProduct._id]),
      expression: "productCartNum[currentProduct._id]"
    }],
    staticClass: "count-num",
    style: ({
      visibility: _vm.productCartNum[_vm.currentProduct._id] ? 'visible' : 'hidden'
    }),
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.productCartNum[_vm.currentProduct._id])
    },
    on: {
      "change": function($event) {
        return _vm.alterNum(_vm.currentProduct, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productCartNum, _vm.currentProduct._id, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "count-btn minus-btn",
    style: ({
      visibility: _vm.productCartNum[_vm.currentProduct._id] ? 'visible' : 'hidden'
    }),
    on: {
      "click": function($event) {
        return _vm.removeSpecFromCart(_vm.currentProduct)
      }
    }
  }, [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-options"
  }, [_c('p', {
    staticClass: "goods-count",
    on: {
      "click": function($event) {
        return _vm.toggleCart()
      }
    }
  }, [_c('i'), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.productCartTotalNum))]), _c('span', {
    staticClass: "price"
  }, [_vm._v("¥" + _vm._s(_vm.totalPrice))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPrice < 0.001),
      expression: "totalPrice < 0.001"
    }],
    staticClass: "min-fee"
  }, [_vm._v("起送金额" + _vm._s(_vm.minMoney) + "元")])]), _vm._v(" "), _c('button', {
    staticClass: "go-order",
    attrs: {
      "disabled": _vm.totalPrice < 0.001
    },
    on: {
      "click": function($event) {
        return _vm.goCheckout()
      }
    }
  }, [_vm._v("\n      立即下单\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "open-time"
  }, [_c('p', [_vm._v("本店打烊啦！")]), _vm._v(" "), _c('p', [_vm._v("营业时间6：00-23：30")]), _vm._v(" "), _c('p', [_vm._v("欢迎明日光临!")])])
}]}

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "phone",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "clear-phone",
    on: {
      "click": function($event) {
        _vm.phone = ''
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.phoneValidate),
      expression: "!phoneValidate"
    }],
    staticClass: "tips"
  }, [_vm._v("请输入正确的手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "code",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "get-code",
    attrs: {
      "disabled": _vm.phoneValidate && _vm.buttonText == '获取验证码' ? null : 'disabled'
    },
    on: {
      "click": function($event) {
        return _vm.getCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeValidate),
      expression: "!codeValidate"
    }],
    staticClass: "tips"
  }, [_vm._v("请输入正确的验证码")]), _vm._v(" "), _c('button', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("登录")])])
},staticRenderFns: []}

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-list"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.getOrdersByDateRange(new Date().setHours(-24, 0, 0, 0), new Date().setHours(47, 59, 59, 59))
      }
    }
  }, [_vm._v("昨日订单")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.getOrdersByDateRange(new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59))
      }
    }
  }, [_vm._v("今日订单")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.getOrdersByDateRange(0, new Date().setHours(23, 59, 59, 59))
      }
    }
  }, [_vm._v("全部订单")]), _vm._v(" "), (!_vm.orders.length) ? _c('div', {
    staticClass: "order-404"
  }, [_vm._v("\n    暂时没有订单！\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order._id,
      staticClass: "order-item",
      on: {
        "click": function($event) {
          return _vm.goToDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "order-no"
    }, [_c('span', {
      staticClass: "order-name"
    }, [_vm._v("订单编号：" + _vm._s(order._id))]), _vm._v(" "), _c('span', {
      staticClass: "order-status"
    }, [_vm._v(_vm._s(_vm._f("calStatus")(order.status)))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-item"
    }, [_c('ul', _vm._l((order.products), function(g, index) {
      return _c('li', {
        key: g._id + index
      }, [_c('p', {
        staticClass: "cart-item"
      }, [_c('span', [_vm._v(_vm._s(g.name) + _vm._s(g.spec ? (" [" + (g.spec) + "]") : ""))]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_vm._v("¥" + _vm._s(Math.round(100 * g.quantity * g.price) / 100))]), _vm._v(" "), (g.unit2) ? _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v("(" + _vm._s(g.quantity / (Number((g.unit2 && g.priceTransfer || 1)))) + _vm._s(g.unit2 || '份') + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "quantity"
      }, [_vm._v("    " + _vm._s(g.quantity) + _vm._s(g.unit || '斤'))]), _vm._v(" "), (g.suppliers && g.suppliers[0] && g.suppliers[0] !== order.supplier._id) ? _c('span', {
        staticStyle: {
          "float": "right",
          "color": "red"
        }
      }, [_vm._v(_vm._s(_vm.supplierMap[g.suppliers[0]]))]) : _vm._e()])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "total-price"
    }, [_c('span', {
      staticClass: "created_time"
    }, [_vm._v(_vm._s(_vm._f("filterTime")(order.createTime)))]), _vm._v(" "), _c('span', [_vm._v("总计：¥" + _vm._s(order.roughPrice) + " | " + _vm._s(_vm.STATUS_MAP[order.status]))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', [_vm._v("备注：" + _vm._s(order.notes))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info"
    }, [_c('span', {
      staticClass: "customer"
    }, [_vm._v("客户：" + _vm._s(order.customer.name))]), _vm._v(" "), _c('span', {
      staticClass: "supplier"
    }, [_vm._v("配送员：" + _vm._s(order.delivery && order.delivery.name))])])])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout"
  }, [_vm._v("\n  new address\n  "), _c('span', [_vm._v("上海")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.district),
      expression: "district"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.district = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "putuo"
    }
  }, [_vm._v("普陀")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jinan"
    }
  }, [_vm._v("静安")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.street),
      expression: "street"
    }],
    attrs: {
      "type": "text",
      "placeholder": "街道门牌号"
    },
    domProps: {
      "value": (_vm.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.street = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.saveAddress()
      }
    }
  }, [_vm._v("保存")])])
},staticRenderFns: []}

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_Vue__ = __webpack_require__(92);




var http = __WEBPACK_IMPORTED_MODULE_2__lib_Vue__["a" /* default */].prototype.$http;

/* harmony default export */ __webpack_exports__["a"] = ({
  getProducts: function getProducts(forCustomer, cb) {
    http.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + ('/api/product/list' + (forCustomer ? '?forCustomer=' + forCustomer : '')), { credentials: 'include' }).then(function (res) {
      cb(res.data);
    });
  },
  buyProducts: function buyProducts(forCustomer, order, cb, errorCb) {
    http.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + ('/api/order' + (forCustomer ? '?forCustomer=' + forCustomer : '')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, order)).then(function (response) {
      cb(response.data);
    });
  },
  getAddresses: function getAddresses(forCustomer, cb) {
    http.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + ('/api/address/list' + (forCustomer ? '?forCustomer=' + forCustomer : ''))).then(function (response) {
      cb(response.data.data);
    });
  },
  updateAddresses: function updateAddresses(address) {
    var token = localStorage.getItem('roupooToken');

    http.patch(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + ('/admin/api/v1/address/' + address.id + '.json'), { data: address }).then(function (response) {});
  },
  newAddress: function newAddress(forCustomer, _ref, cb, errorCb) {
    var tel = _ref.tel,
        name = _ref.name,
        street = _ref.street;

    http.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + ('/api/address' + (forCustomer ? '?forCustomer=' + forCustomer : '')), { tel: tel, name: name, street: street }).then(function (response) {
      cb(response.data.data);
    });
  },
  editAddress: function editAddress(forCustomer, _ref2, cb, errorCb) {
    var tel = _ref2.tel,
        name = _ref2.name,
        street = _ref2.street,
        _id = _ref2._id;

    http.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + '/api/address/' + _id + (forCustomer ? '?forCustomer=' + forCustomer : ''), { tel: tel, name: name, street: street, _id: _id }).then(function (response) {
      cb(response.data.data);
    });
  },
  getOrders: function getOrders(cb) {
    http.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* host */] + '/api/order/list').then(function (response) {
      cb(response.data.data);
    });
  }
});

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ALTER_SPEC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ALTER_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CHECKOUT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CHECKOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHECKOUT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIVE_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_FOR_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECEIVE_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return REMOVE_FROME_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_ADDRESSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NEW_ADDRESSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EDIT_ADDRESSES; });
/* unused harmony export SAVE_ADDRESSES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLEAR_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ALTER_NUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ORDER_ID; });
var ADD_TO_CART = 'ADD_TO_CART';
var ALTER_SPEC = 'ALTER_SPEC';
var ALTER_UNIT = 'ALTER_UNIT';
var CHECKOUT_REQUEST = 'CHECKOUT_REQUEST';
var CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';
var CHECKOUT_FAILURE = 'CHECKOUT_FAILURE';
var RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';
var SET_FOR_CUSTOMER = 'SET_FOR_CUSTOMER';
var RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES';
var REMOVE_FROME_CART = 'REMOVE_FROME_CART';
var GET_ADDRESSES = 'GET_ADDRESSES';
var NEW_ADDRESSES = 'NEW_ADDRESSES';
var EDIT_ADDRESSES = 'EDIT_ADDRESSES';
var SAVE_ADDRESSES = 'SAVE_ADDRESSES';
var CLEAR_CART = 'CLEAR_CART';
var GET_ORDERS = 'GET_ORDERS';
var ALTER_NUM = 'ALTER_NUM';
var SET_ORDER_ID = 'SET_ORDER_ID';

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.request.use(function (config) {
    var token = localStorage.getItem('roupoo-token');

    config.headers.Authorization = token;
    return config;
});

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(function (response) {
    return response;
}, function (err) {
    if (401 === err.response.status) {
        window.location.href = '/login';
    } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]);

/***/ })

},[237]);


// WEBPACK FOOTER //
// static/js/app.99c44233d2689ff66a60.js